export const customersTranslations = {
  ar: {
    title: 'العملاء',
    addNew: 'اضافة جديد',
    search: 'بحث',
    searchLogic: 'منطق البحث',
    searchAllWords: 'كل الكلمات (و)',
    searchAnyWord: 'أي كلمة (أو)',
    searchHint: 'عدة كلمات مفصولة بمسافة؛ استخدم \"نص\" للعبارة كاملة',
    serial: 'التسلسل',
    name: 'الاسم',
    nbrTax: 'الرقم الضريبي',
    mobile: 'جوال',
    email: 'البريد الإلكتروني',
    phone2: 'هاتف إضافي',
    whatsAppNumber: 'واتساب',
    website: 'موقع إلكتروني',
    contactSection: 'وسائل التواصل',
    address: 'العنوان',
    branch: 'الفرع',
    edit: 'تعديل',
    delete: 'حذف',
    copy: 'نسخ',
    paste: 'لصق',
    view: 'عرض',
    list: 'قائمة',
    save: 'حفظ',
    cancel: 'إلغاء',
    noCustomers: 'لا يوجد عملاء',
    loading: 'جاري تحميل العملاء...',
    error: 'فشل تحميل العملاء',
    saveSuccess: 'تم حفظ العميل بنجاح',
    saveError: 'فشل حفظ العميل',
    deleteSuccess: 'تم حذف العميل بنجاح',
    deleteError: 'فشل حذف العميل',
    copySuccess: 'تم نسخ العميل',
    pasteSuccess: 'تم لصق العميل بنجاح',
    pasteError: 'لا يوجد عميل منسوخ',
    description: 'الوصف',
    selectBranch: 'اختر الفرع',
    isActive: 'نشط',
    isVisibleInPos: 'ظاهر في نقطة البيع',
    buildingNo: 'رقم المبنى',
    district: 'الحي',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    streetName: 'اسم الشارع',
    country: 'الدولة',
    additionalNo: 'الرقم الإضافي',
    registerNo: 'رقم السجل',
    previous: 'السابق',
    next: 'التالي',
    page: 'صفحة',
    of: 'من',
    showing: 'عرض',
    to: 'إلى',
    results: 'نتيجة',
  },
  en: {
    title: 'Customers',
    addNew: 'Add New',
    search: 'Search',
    searchLogic: 'Search logic',
    searchAllWords: 'All words (AND)',
    searchAnyWord: 'Any word (OR)',
    searchHint: 'Separate words with spaces; use \"phrase\" for an exact phrase',
    serial: 'Serial',
    name: 'Name',
    nbrTax: 'Tax Number',
    mobile: 'Mobile',
    email: 'Email',
    phone2: 'Additional phone',
    whatsAppNumber: 'WhatsApp',
    website: 'Website',
    contactSection: 'Contact details',
    address: 'Address',
    branch: 'Branch',
    edit: 'Edit',
    delete: 'Delete',
    copy: 'Copy',
    paste: 'Paste',
    view: 'View',
    list: 'List',
    save: 'Save',
    cancel: 'Cancel',
    noCustomers: 'No customers',
    loading: 'Loading customers...',
    error: 'Failed to load customers',
    saveSuccess: 'Customer saved successfully',
    saveError: 'Failed to save customer',
    deleteSuccess: 'Customer deleted successfully',
    deleteError: 'Failed to delete customer',
    copySuccess: 'Customer copied',
    pasteSuccess: 'Customer pasted successfully',
    pasteError: 'No customer copied',
    description: 'Description',
    selectBranch: 'Select Branch',
    isActive: 'Active',
    isVisibleInPos: 'Visible in POS',
    buildingNo: 'Building No',
    district: 'District',
    city: 'City',
    postalCode: 'Postal Code',
    streetName: 'Street Name',
    country: 'Country',
    additionalNo: 'Additional No',
    registerNo: 'Register No',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    of: 'of',
    showing: 'Showing',
    to: 'to',
    results: 'results',
  },
  fr: {
    title: 'Clients',
    addNew: 'Ajouter nouveau',
    search: 'Rechercher',
    searchLogic: 'Logique de recherche',
    searchAllWords: 'Tous les mots (ET)',
    searchAnyWord: 'Un des mots (OU)',
    searchHint: 'Mots séparés par des espaces ; utilisez \"phrase\" pour une expression exacte',
    serial: 'Série',
    name: 'Nom',
    nbrTax: 'Numéro fiscal',
    mobile: 'Mobile',
    email: 'E-mail',
    phone2: 'Téléphone supplémentaire',
    whatsAppNumber: 'WhatsApp',
    website: 'Site web',
    contactSection: 'Coordonnées',
    address: 'Adresse',
    branch: 'Succursale',
    edit: 'Modifier',
    delete: 'Supprimer',
    copy: 'Copier',
    paste: 'Coller',
    view: 'Voir',
    list: 'Liste',
    save: 'Enregistrer',
    cancel: 'Annuler',
    noCustomers: 'Aucun client',
    loading: 'Chargement des clients...',
    error: 'Échec du chargement des clients',
    saveSuccess: 'Client enregistré avec succès',
    saveError: 'Échec de l\'enregistrement du client',
    deleteSuccess: 'Client supprimé avec succès',
    deleteError: 'Échec de la suppression du client',
    copySuccess: 'Client copié',
    pasteSuccess: 'Client collé avec succès',
    pasteError: 'Aucun client copié',
    description: 'Description',
    selectBranch: 'Sélectionner la succursale',
    isActive: 'Actif',
    isVisibleInPos: 'Visible au PDV',
    buildingNo: 'Numéro du bâtiment',
    district: 'Quartier',
    city: 'Ville',
    postalCode: 'Code postal',
    streetName: 'Nom de la rue',
    country: 'Pays',
    additionalNo: 'Numéro supplémentaire',
    registerNo: 'Numéro d\'enregistrement',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
    showing: 'Affichage',
    to: 'à',
    results: 'résultats',
  },
}


